import isEmpty from "lodash-es/isEmpty";

import actionTypes from "../actionTypes";

const initialState = {
  token: null,
  posToken: null,
  clientType: null,
  posType: null,
  outletId: null,
};

function posAuthReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_POS_AUTH_TOKEN: {
      const patch = action.payload || {};
      const next = { ...state };
      for (const key of Object.keys(initialState)) {
        next[key] = isEmpty(patch[key]) ? null : patch[key];
      }
      return next;
    }
    case actionTypes.CLEAR_POS_AUTH_TOKEN:
      return initialState;
    default:
      return state;
  }
}

export default posAuthReducer;
